module.exports = __webpack_public_path__ + "static/media/union.e6253705.png";